import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import './PasswordChangeModal.css';

function PasswordChangeModal() {
  const { updatePassword } = useAuth();
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    // Validation
    if (!currentPassword || !newPassword || !confirmPassword) {
      setError('Please fill in all fields');
      return;
    }

    if (newPassword !== confirmPassword) {
      setError('New passwords do not match');
      return;
    }

    if (newPassword.length < 6) {
      setError('New password must be at least 6 characters');
      return;
    }

    if (newPassword === currentPassword) {
      setError('New password must be different from current password');
      return;
    }

    if (newPassword === 'Debate212') {
      setError('Please choose a different password than the default');
      return;
    }

    setLoading(true);

    try {
      const result = await updatePassword(currentPassword, newPassword);
      if (result.success) {
        // Success! The modal will close automatically when needsPasswordChange becomes false
        // The page will reload or update
      } else {
        setError(result.error || 'Failed to change password. Please check your current password.');
      }
    } catch (err) {
      setError('An unexpected error occurred');
    }

    setLoading(false);
  };

  return (
    <div className="password-change-modal-overlay">
      <div className="password-change-modal">
        <div className="modal-header">
          <h2>Password Change Required</h2>
          <p>For security reasons, you must change your password before continuing.</p>
        </div>

        <form onSubmit={handleSubmit} className="password-change-form">
          {error && (
            <div className="error-alert">
              {error}
            </div>
          )}

          <div className="form-field">
            <label htmlFor="currentPassword">Current Password</label>
            <input
              type="password"
              id="currentPassword"
              value={currentPassword}
              onChange={(e) => setCurrentPassword(e.target.value)}
              placeholder="Enter your current password (Debate212)"
              disabled={loading}
              autoFocus
            />
          </div>

          <div className="form-field">
            <label htmlFor="newPassword">New Password</label>
            <input
              type="password"
              id="newPassword"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              placeholder="Enter new password (min 6 characters)"
              disabled={loading}
            />
          </div>

          <div className="form-field">
            <label htmlFor="confirmPassword">Confirm New Password</label>
            <input
              type="password"
              id="confirmPassword"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              placeholder="Confirm new password"
              disabled={loading}
            />
          </div>

          <button
            type="submit"
            className="submit-button"
            disabled={loading}
          >
            {loading ? 'Changing Password...' : 'Change Password'}
          </button>
        </form>

        <div className="modal-footer">
          <p className="info-text">
            <strong>Note:</strong> You cannot access the application until you change your password.
          </p>
        </div>
      </div>
    </div>
  );
}

export default PasswordChangeModal;
